import { ObjectValues } from 'types';

export type ListenEvents = ObjectValues<typeof LISTEN_EVENTS>;
export const LISTEN_EVENTS = {
  NOTIFICATION_CREATED: 'notification-created',
  MESSAGE_CREATED: 'message-created',
  MESSAGE_DELETED: 'message-deleted',
  MESSAGE_SEEN: 'message-seen',
  LEADS_STATE_CHANGED: 'leads-state-changed',
  LISTING_PAID: 'listing-paid',
  NODE_PROCESSED_SUCCESSFULLY: 'processed-successfully',
  DATA_ROOM_INDEX_UPDATED: 'data-room-index-updated',
  DOWNLOAD_SUCCESSFULLY: 'downloaded-successfully',
  DOWNLOAD_FAILED: 'downloaded-failed',
  DATA_ROOM_ARCHIVE_UPDATED: 'data-room-archive-updated',
  NDA_STATUS_UPDATE: 'nda-status-update',
  NEW_FILES: 'new-accessable-files',
  FILE_CONVERSION_FAILED: 'file-conversion-failed',
  DATA_ROOM_MEMBERS_UPDATED: 'data-room-members-updated',
  NEW_MESSAGE_FILES: 'chat-files-uploaded',
  WAITING_ROOM_UPDATED: 'waiting-room-updated',
  NDAS_UPDATED: 'data-room-ndas-updated',
  RFIS_UPDATED: 'data-room-rfis-updated',
  DR_BULK_CREATED: 'data-rooms-bulk-created',
  DATA_ROOM_STORAGE_CHANGED: 'data-room-storage-changed',
};
